module.exports = __webpack_public_path__ + "img/tabbed-search-filter-v-search-bar-light.e6cc1dc6.png";